import {faChevronDown} from '@fortawesome/pro-light-svg-icons/faChevronDown';
import type {DropdownIndicatorProps, GroupBase} from 'chakra-react-select';
import {chakraComponents} from 'chakra-react-select';

import {SelectIcon} from './SelectIcon';

export const DropdownIndicator = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: DropdownIndicatorProps<Option, IsMulti, Group>,
) => {
  if (props.selectProps.isLoading) {
    return null;
  }
  return (
    <chakraComponents.DropdownIndicator {...props}>
      <SelectIcon fontSize={`md`} icon={faChevronDown} transform={props.isFocused ? `rotate(180deg)` : undefined} />
    </chakraComponents.DropdownIndicator>
  );
};
